import {
    IsFollowerOfCreativeSetResponse,
    ShowcaseCreativeSetsIsFollowerListParams,
    ShowcaseFollowCreativeSetRequest,
    ShowcaseUnfollowCreativeSetRequest
} from '@bannerflow/types.notification-orchestrator';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const loadActions = createActionGroup({
    source: 'FollowCreativeSet',
    events: {
        load: props<{ creativeSetId: number }>(),
        'load success': props<IsFollowerOfCreativeSetResponse>(),
        'load failure': props<{ error: unknown }>()
    }
});

export const followActions = createActionGroup({
    source: 'FollowCreativeSet',
    events: {
        follow: props<{ creativeSetId: number }>(),
        'follow success': emptyProps(),
        'follow failure': props<{ error: unknown }>()
    }
});

export const unfollowActions = createActionGroup({
    source: 'FollowCreativeSet',
    events: {
        unfollow: props<{ creativeSetId: number }>(),
        'unfollow success': emptyProps(),
        'unfollow failure': props<{ error: unknown }>()
    }
});

export const showcaseLoadActions = createActionGroup({
    source: 'FollowCreativeSet-Showcase',
    events: {
        init: props<{ creativeSetId: number }>(),
        'init success': props<{ userEmail: string; userName: string; creativeSetId: number }>(),
        load: props<ShowcaseCreativeSetsIsFollowerListParams>(),
        'load success': props<IsFollowerOfCreativeSetResponse>(),
        'load failure': props<{ error: unknown }>()
    }
});

export const showcaseFollowActions = createActionGroup({
    source: 'FollowCreativeSet-Showcase',
    events: {
        follow: props<ShowcaseFollowCreativeSetRequest & { creativeSetId: number }>(),
        'follow success': emptyProps(),
        'follow failure': props<{ error: unknown }>()
    }
});

export const showcaseUnfollowActions = createActionGroup({
    source: 'FollowCreativeSet-Showcase',
    events: {
        unfollow: props<ShowcaseUnfollowCreativeSetRequest & { creativeSetId: number }>(),
        'unfollow success': emptyProps(),
        'unfollow failure': props<{ error: unknown }>()
    }
});
